<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>库存管理</el-breadcrumb-item>
            <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>

            <div class="kaidan_body">
                <div style="width: 150px;" v-if="true">
                    <el-steps :active="cardShow - 1" align-center direction="vertical">
                        <el-step title="选择门店" description="选择门店" @click.native="menu_set(1)"></el-step>
                        <el-step title="出库" description="出库" @click.native="menu_set(2)"></el-step>
                    </el-steps>
                </div>

                <div style="width: 100%;" class="kaidan">

                    <div class="kaidan">
                        <el-card v-if="cardShow_xianshi === 1" class="card_style">
                            <div v-if="cardShow_sub === 1">
                                <mendian ref="mendianListRef" caozuo_type="1" @getMendianInfo="getMendianInfo"> </mendian>
                            </div>
                        </el-card>
                        <el-card v-if="cardShow_xianshi === 2" class="card_style">
                            <div class="mendian_body">
                                <div style="width: 80px;">门店信息</div>
                                <div style="width: 80px;"></div>
                                <div style="width: 250px;">
                                    <span style="width: 200px;">编号: </span>
                                    <span class="mendianInfo">{{ mendianUidInfo.qiye_bianhao }}</span>
                                </div>
                                <div style="width: 250px;">
                                    <span style="width: 80px;"> 名称: </span>
                                    <span class="mendianInfo">{{ mendianUidInfo.qiye_name }}</span>
                                </div>
                                <div>
                                    <span style="width: 80px;">手机: </span>
                                    <span class="mendianInfo">{{ mendianUidInfo.qiye_mob
                                    }}</span>
                                </div>
                            </div>
                            <div v-if="cardShow_sub === 1">

                                <chukuDo ref="chukuDoRef" caozuo_type="1" @closeChuku="closeChuku" :mendianUid="mendianUidInfo.uid"  :productTypeSelect="5" key="datekey">
                                </chukuDo>
                            </div>

                        </el-card>

                    </div>
                </div>
            </div>
        </el-card>
        <div style="margin-top: 10px;text-align: center;"><span slot="footer" class="dialog-footer">
                <el-button @click="quxiao">关闭窗口</el-button>
                <el-button type="primary" @click="addChuku" :disabled="add_isDisable">{{ button_text }}</el-button>
            </span> </div>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../config/validator';
import mendian from '../mendianSelect.vue'
import chukuDo from './chuku_do.vue'
export default {
    components: {
        chukuDo: chukuDo,
        mendian: mendian
    },
    data() {
        return {
       
            mendianUidInfo: {
                uid: 0
            },
            errFlag: 0,
            datekey: Date.now(),
            // editUid_cheliang: 0, // 修改uid
            // car_update_flag: 0, // 是否为新添加 车辆资料 1 新车型 2 已有车型
            // guest_update_flag: 0, // 是否为新添加客户， 1位新客户 2为已有客户
            array_cardShow_sub: [],
            // kaidan_title: '01-01:请输入车牌',
            button_text: '下一步',
            // isCollapse002: true,
            cardShow: 1, // 主模块控制标记
            cardShow_sub: 1, // 子元素显示标记
            add_isDisable: false,
            cardShow_xianshi: 1 // 用于显示
           
        };
    },
    created() {
        // this.getorderList();
        console.log('强制刷新')
        // this.getBianhao_order()
    },
    methods: {
        closeChuku() {
            this.cardShow = 1
            this.cardShow_sub = 1
            this.cardShow_xianshi = this.cardShow
            // this.$refs.mendianListRef.mendianUidSelect = 0
        },
        async addChuku() {
            if ((this.cardShow === 1) && (this.cardShow_sub === 1)) {
                console.log(9999, this.mendianUidInfo.uid)
                if (this.mendianUidInfo.uid === 0) {
                      this.$message.error('请选择门店！')
                    return 0
                }
                console.log(999, this.mendianUid)
                if ((this.cardShow === 1) && (this.cardShow_sub === 1)) {
                    this.kaidan_title_set(2)
                    this.cardShow = 2
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                }
                return 0
            }
            if ((this.cardShow === 2) && (this.cardShow_sub === 1)) {
                await this.$refs.chukuDoRef.product_chuku()
                this.$emit('flushKucunPage', 1)
                return 0
            }
        },
        getMendianInfo(mendianUidInfo) {
            this.mendianUidInfo = mendianUidInfo
            // this.mendianUid = mendianUidInfo.uid
            
            this.addChuku()
        },
        get_order_selected_uid(data) {
            console.log('array_order_uid_selected', data)
            this.arrayOrderUidSelected = data
        },
        menu_set(type) {
            // console.log(type)
            if (this.cardShow >= type) {
                this.kaidan_title_set(type)
                this.cardShow_xianshi = type
                this.cardShow = type
                this.cardShow_sub = 1
            }
        },
        quxiao() {
            this.menu_set(1)
            this.$emit('chuku_addClose', 0)
        },
        kaidan_title_set(type) {
            console.log('当前位置', this.cardShow_xianshi, this.cardShow, this.cardShow_sub)
            if (type === 1) {
                this.cardShow_xianshi = this.cardShow
                this.array_cardShow_sub[this.cardShow - 1] = this.cardShow_sub
            }

            return 0
        },
        test_pro() {
            console.log(8888, this.cardShow_xianshi, this.cardShow, this.cardShow_sub, this.addForm)
        },
        err_chuli(type, data) {
            if (data.uid === -1) {
                this.$message.error(type === 1 ? '车辆添加出错' : type === 2 ? '外观添加出错' : '客户添加出错')
                return 0
            }
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
    height: 650px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}

.kaidan {
    display: flex;
    flex-direction: column;

}

.card_style {
    height: 700px;
    // overflow-y: auto;
}

.kaidan_title {
    background-color: #eee;
    width: 100%;
    height: 40px;
    font-size: 30px;
    color: black;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    padding-top: 8px;
}

.kaidan_body {
    display: flex;
    flex-direction: row;
    height: 700px;

}

.mendian_body {
    display: flex;
    flex-direction: row;
    height: 60px;
    width: 100%;

}

.card_gundong {
    // overflow-y: auto;
    max-height: 500px;
    max-width: 500px;
}

.mendianInfo {
    font-size: large;
    font-weight: 350;
    color: #515151;
    text-decoration: underline;
}
</style>
